import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Loading } from '../components/feedback/Loading'
import { ProtectedLayout } from '../components/layout/ProtectedLayout'

// Carga diferida de páginas → integra el sistema de carga (Suspense).
const LoginPage = lazy(() => import('../pages/LoginPage'))
const HomePage = lazy(() => import('../pages/HomePage'))
const AnalyzeCompanyPage = lazy(() => import('../pages/AnalyzeCompanyPage'))
const HistoryPage = lazy(() => import('../pages/HistoryPage'))
const SettingsPage = lazy(() => import('../pages/SettingsPage'))
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'))

export function AppRouter() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <Suspense fallback={<Loading label="Cargando…" />}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/analyze" element={<AnalyzeCompanyPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
